module.exports = new __parcel__URL__("capacity-preview.5785524a.svg").toString();